import axios from "axios";

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_ROUTE,
    headers: {
        "Content-Type": "multipart/form-data",
    }
});

instance.interceptors.request.use(
    function (config) {
        const token = localStorage.getItem("sunkwa_token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export default instance;